// src/components/player-profile/StatsTab.js
//
// Extracted from inline closure in PlayerProfileModal.js per IMPORTANT
// batch 8 commit 8b (refactor only — no behavior change).
//
// Closure-→-prop conversion: 5 closure-captured variables promoted to
// declared props (player, isPitcher, scoringCategories, rosterStatus,
// renderStatsRow). renderStatsRow is passed as a function-prop —
// parent's ~150-LoC helper closure stays in parent (captures parent
// state); function-prop is simpler bounded path than utility extraction.
import React from 'react';
import { ChartBar } from 'lucide-react';
import { dynastyTheme } from '../../services/colorService';

const StatsTab = ({ player, isPitcher, scoringCategories, rosterStatus, renderStatsRow }) => (
  <div className="space-y-4">
    {player && (
      <div className={`${dynastyTheme.components.card.base} p-4`}>
        <h4 className={`${dynastyTheme.classes.text.primary} font-semibold mb-3 flex items-center`}>
          <ChartBar className="w-4 h-4 mr-2" />
          Performance Statistics
        </h4>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-neutral-700">
                <th className={`py-2 px-3 text-left text-sm ${dynastyTheme.classes.text.neutralLight}`}>
                  Period
                </th>
                {(() => {
                  if (isPitcher()) {
                    const baseCols = ['G', 'GS', 'IP'];
                    const leagueCats = scoringCategories?.pitching || ['W', 'SV', 'ERA', 'WHIP', 'K', 'QS'];
                    return [...baseCols, ...leagueCats].map(col => (
                      <th key={col} className={`py-2 px-3 text-center text-sm ${dynastyTheme.classes.text.neutralLight}`}>
                        {col}
                      </th>
                    ));
                  } else {
                    const baseCols = ['AB', 'H', 'BB', 'SO'];
                    const leagueCats = scoringCategories?.hitting || ['R', 'HR', 'RBI', 'SB', 'AVG', 'OPS'];
                    return [...baseCols, ...leagueCats].map(col => (
                      <th key={col} className={`py-2 px-3 text-center text-sm ${dynastyTheme.classes.text.neutralLight}`}>
                        {col}
                      </th>
                    ));
                  }
                })()}
              </tr>
            </thead>
            <tbody>
              {player.stats?.season && renderStatsRow('Season', player.stats.season)}
              {player.stats?.rolling_14_day && renderStatsRow('L14', player.stats.rolling_14_day)}
              {rosterStatus === 'owned' && player.accrued_stats && renderStatsRow('Accrued', player.accrued_stats)}
            </tbody>
          </table>
        </div>

        <div className="mt-4 pt-4 border-t border-neutral-700">
          <div className={`grid ${rosterStatus === 'owned' ? 'grid-cols-3' : 'grid-cols-2'} gap-2 text-xs`}>
            <div className="flex items-center">
              <div className="w-3 h-3 bg-neutral-600 rounded mr-2"></div>
              <span className={dynastyTheme.classes.text.neutralLight}>Season: Full 2025 stats</span>
            </div>
            <div className="flex items-center">
              <div className="w-3 h-3 bg-neutral-600 rounded mr-2"></div>
              <span className={dynastyTheme.classes.text.neutralLight}>L14: Last 14 days</span>
            </div>
            {rosterStatus === 'owned' && (
              <div className="flex items-center">
                <div className="w-3 h-3 bg-yellow-400/20 rounded mr-2"></div>
                <span className={dynastyTheme.classes.text.neutralLight}>Accrued: While on roster</span>
              </div>
            )}
          </div>
        </div>
      </div>
    )}

    {!player && (
      <div className={`${dynastyTheme.components.card.base} p-8 text-center`}>
        <p className={dynastyTheme.classes.text.neutralLight}>Loading player statistics...</p>
      </div>
    )}
  </div>
);

export default StatsTab;
